import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import { Segment, Form, Input, Dropdown, TextArea, Button, Header, Divider, Icon, List, Modal, Popup, Loader } from 'semantic-ui-react';
import L from 'leaflet';
import Draw from './Draw';
import FileUpload from './Documents/FileUpload';
import ConfirmModal from './ConfirmModal';
import {updateEditShapesStatus} from '../actions/conservationActions';
import { updateSurveyDefinition, deleteAllLayers, deleteResponse } from '../../../modules/surveys';
import { Formik, FastField } from 'formik';
import axios from "axios/index";



class NewResponseTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            geometries: props.geometries,
            responseErrors: {},
            files: [],
            filesToAdd: [],
            filesToDelete: [],
            uploading: false
        };
        let validations = null
    }

    componentDidMount() {
        const { getResponse } = this.props

        if (this.props.responseID !== null) {
            this.props.geometries.forEach(geom => {
                this.props.map.drawLayer.addData(geom.geom)
            });
            getResponse(this.props.responseID).then(response => {
                this.setState({files: response.data.documents})
            })
        }

        let validations = {}

        const gatherValidations = (fieldInfo, group = null) => {
            const id = (group) ? `${group}:${fieldInfo.id}` : fieldInfo.id;
            const {args, type: fieldType} = fieldInfo
            const {required, max_length, min_value} = args

            if (required) {
                validations[id] ? validations[id].required = true : validations[id] = {required: true}
            }
            if (max_length) {
                validations[id] ? validations[id].max_length = max_length : validations[id] = {max_length: max_length}
            }
            if (fieldType === "float") {
                validations[id] ? validations[id].float = true : validations[id] = {float: true}
                if (!isNaN(min_value)) {
                    validations[id].min_value = min_value
                }
            }
            if (fieldType === "email") {
                validations[id] ? validations[id].email = true : validations[id] = {email: true}
            }
        }

        this.props.data.forEach(field => {
            if (field.fields && field.fields.length) {
                field.fields.forEach(f => gatherValidations(f, field.id))
            } else {
                gatherValidations(field)
            }

        })

        this.validations = validations
    }

    componentWillUnmount() {
        this.props.map.drawLayer.clearLayers();
        this.props.deleteAllLayers()
    }

    // If front end validation is working correctly, this will never run
    highlightErrors() {
        Object.keys(this.state.responseErrors).forEach((field) => {
            const err = this.state.responseErrors[field]
            document.getElementById(field).innerHTML = err.length ? err.join(", ") : err
        })
    }

    onDrop(files) {
        this.setState({uploading: true})

        const numberOfFiles = files.length
        let failedValidation = []
        let numberOfResponsesBack = 0

        Object.values(files).forEach(file => {
            const fileName = file.name
            let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.pdf|\.doc|\.docx|\.xls|\.xlsx|\.zip|\.txt|\.csv\.accdb|\.key|\.kml|\.kmz|\.mdb|\.odf|\.ods|\.odt|\.otp|\.ots|\.ott|\.ppt|\.pptx|\.rtf|\.tiff|\.xml)$/i;
            // limit file size to 100MB
            if (file.size > 100000000 || !allowedExtensions.exec(fileName)) {
                failedValidation.push(fileName)
            } else {
                const config = {headers: {'content-type': 'multipart/form-data'}}
                const formData = new FormData();
                formData.append('file', file)
                axios.post(
                    window.Util.reverseURL("uploads:temporary_file_for_attachment"),
                    formData,
                    config)
                    .then(response => {
                        numberOfResponsesBack ++;
                        if (numberOfResponsesBack + failedValidation.length === numberOfFiles) {
                            this.setState({
                                uploading: false,
                                filesToAdd: this.state.filesToAdd.concat([
                                    {
                                        fileName,
                                        url: response.data.url,
                                        uuid: response.data.uuid,
                                        editName: false,
                                        newName: ""
                                    }
                                ])
                            })
                        } else {
                            this.setState({
                                filesToAdd: this.state.filesToAdd.concat([
                                    {
                                        fileName,
                                        url: response.data.url,
                                        uuid: response.data.uuid,
                                        editName: false,
                                        newName: ""
                                    }
                                ])
                            })
                        }

                    })
                    .catch(error => {
                        console.log("temp file upload failed: ", error)
                        numberOfResponsesBack++;
                        if (numberOfResponsesBack + failedValidation.length === numberOfFiles) {
                            this.setState({uploading: false})
                        }
                    });
            }
        })
        if (failedValidation.length > 0) {
            alert(`${failedValidation.join(", ")} could not be uploaded. Files must have extension jpg, jpeg, png, gif, pdf, doc, docx, xls, xlsx, zip, txt, csv, accdb, key, kml, kmz, mdb, odf, ods, odt, otp, ots, ott, ppt, pptx, rtf, tiff, or xml and must be of the under 100MB in size.`);
        }
        if (failedValidation.length === numberOfFiles) {
            this.setState({uploading: false})
        }
    }

    destroyResponse() {
        axios.delete(window.Util.reverseURL('api_dispatch_detail', 'v1', 'survey-responses', this.props.responseID))
            .then(response => {
                this.props.deleteResponse(this.props.responseID)
                console.log("response deleted")
            })
            .catch(error => console.log("could not delete response: ", error))
            .finally(() => this.props.onDelete())
    }

    addFile(uuid, name, responseID) {
        axios.post(
            window.Util.reverseURL('api_survey_document_upload', 'v1', responseID),
            {
                'name': name,
                'tmp_file': window.Util.reverseURL('api_dispatch_detail', 'v1', 'uploads/temporary-files', uuid)
            }
        )
        .then(response => {
            console.log("file successfully added to response")
        })
        .catch(error => {
            console.log("file submission failed: ", error)
        })
        .finally(() => this.props.onSubmit())
    }

    deleteFile(id) {
        axios.delete(window.Util.reverseURL('api_dispatch_detail', 'v1', 'survey-documents', id))
        .then(response => {
            console.log("file successfully deleted", response.data)
        })
        .catch(error => {
            console.log("file deletion failed: ", error)
        })
        .finally(() => this.props.onSubmit())
    }

    // Modify this function to save to the current structure of responses
    handleSaveClick(values) {
        if (this.props.responseID === null) {
            this.props.createResponse({
                survey: this.props.surveyID,
                field_data: values,
                geometries: this.props.map.drawLayer.getLayers().map(layer => ({geom: layer.toGeoJSON().geometry}))
            }).then(response => {
                if (this.state.filesToAdd.length > 0) {
                    this.state.filesToAdd.forEach(file => {
                        if (file.newName) {
                            this.addFile(file.uuid, file.newName, response.data.id)
                        } else {
                            this.addFile(file.uuid, file.fileName, response.data.id)
                        }
                    })
                } else {
                    this.props.onSubmit()
                }
            }).catch(error => {
                if (_.get(error, 'response.status') === 400) {
                    const data = error.response.data
                    const responseErrors = Object.assign({}, data.field_data, data.geometries)
                    this.setState({responseErrors})
                    this.highlightErrors()
                } else {
                    throw error;
                }
            });
        } else {
            this.props.editResponse(this.props.responseID, {
                field_data: values,
                geometries: this.props.map.drawLayer.getLayers().map(layer => ({geom: layer.toGeoJSON().geometry}))
            }).then(response => {
                if (this.state.filesToDelete.length > 0) {
                    this.state.filesToDelete.forEach(id => {
                        this.deleteFile(id)
                    })
                }
                else if (this.state.filesToAdd.length > 0) {
                    this.state.filesToAdd.forEach(file => {
                        if (file.newName) {
                            this.addFile(file.uuid, file.newName, this.props.responseID)
                        } else {
                            this.addFile(file.uuid, file.fileName, this.props.responseID)
                        }
                    })
                } else {
                    this.props.onSubmit()
                }
            }).catch(error => {
                if (_.get(error, 'response.status') === 400) {
                    const data = error.response.data
                    const responseErrors = Object.assign({}, data.field_data, data.geometries)
                    this.setState({responseErrors})
                    this.highlightErrors()
                } else {
                    throw error;
                }
            });
        }
    }

    renderDropdown (fieldInfo, id, type, errors, touched) {
        const choices = fieldInfo.args.tooltips ?
            fieldInfo.args.choices.map(c => ({text: c, value: c, title: fieldInfo.args.tooltips[c]})) :
            fieldInfo.args.choices.map(c => ({text: c, value: c}))

        return (
            <FastField
                key={id}
                name={id}
                render={({
                             field,
                             form: {
                                 touched: {[id]: isTouched},
                                 errors: {[id]: error}
                             }
                         }) => (
                    <div>
                        {touched[id] && <div id={id} style={{color: "red"}}>{errors[id]}</div>}
                        <Form.Group widths="equal">
                            <Dropdown
                                className="dropdown-field"
                                placeholder={type === "multiple_choice" ? "Select All That Apply" : "Select One"}
                                fluid
                                search
                                multiple={type === "multiple_choice" ? true : false}
                                selection
                                value={field.value}
                                options={choices}
                                onBlur={(e, {value}) => {
                                    e.target.name = id
                                    e.target.value = value
                                    field.onBlur(e)
                                }}
                                onChange={(e, {value}) => {
                                    e.target.name = id
                                    e.target.value = value
                                    field.onChange(e)
                                }}
                            />
                        </Form.Group>
                    </div>
                )}
            />
        )
    }

    renderInput(fieldInfo, id, type, errors, touched) {
        return (
            <FastField
                key={id}
                name={id}
                render={({
                             field,
                             form: {
                                 touched: {[id]: isTouched},
                                 errors: {[id]: error}
                             }
                         }) => (
                    <div>
                        {isTouched && <div id={id} style={{color: "red"}}>{error}</div>}
                        <Form.Group widths="equal">
                            <Form.Field
                                type={type}
                                control={type === "long_text" ? TextArea : Input}
                                {...field}
                            />
                        </Form.Group>
                    </div>
                )}
            />
        )
    }

    //TODO: args.help_text in not utilized (add tool tip?)
    generateFields(data, values, errors, handleBlur, handleChange, touched) {
        let output = []
        let header = (label, labelId, helpText, required) => {
            return (
                <div key={labelId}>
                    <div className="container-space-between field-header">
                        <Header style={{marginBottom: 0, lineHeight: "23px"}} size="tiny">
                            {gettext(label)}
                        </Header>
                        {required ? <p>&nbsp;</p> : <p>(optional)</p>}
                    </div>
                    {helpText ? <p className="help-text">{helpText}</p> : null}
                </div>
            )
        }
        data.forEach(field => {
            let type = null
            let label = null
            let required = null
            let helpText = null
            if (field.id === "draw_tool_insert") {
                output.push(
                    <div key="draw_tool_insert" id="draw_tool_insert" className="section">
                        {header(field.args.label, "draw_tool_insert", null, true)}
                        <div id="geom" style={{color: "red", paddingButtom: ".5rem"}}>{errors.geometries}</div>
                        {
                            this.props.map ? <Draw
                                className="section"
                                map={this.props.map}
                                geometries={this.state.geometries}
                            /> : null
                        }
                    </div>
                )
            } else if (field.fields && field.fields.length) {
                let section = []
                field.fields.forEach(f => {
                    helpText = f.args.help_text
                    required = f.args.required
                    // label defaults to id
                    label = f.args.label || f.args.id
                    f.type === "float" ? type = "number" : type = f.type
                    if (type === "choice" || type === "multiple_choice") {
                        section.push(
                            header(label, `${label}:${field.id}:${f.id}`, helpText, required),
                            this.renderDropdown(f, `${field.id}:${f.id}`, type, errors, touched)
                        )
                    } else {
                        section.push(
                            header(label, `${label}:${field.id}:${f.id}`, helpText, required),
                            this.renderInput(f, `${field.id}:${f.id}`, type, errors, touched)
                        )
                    }
                })
                output.push([<h3 className="section-header-divider" key={field.label}>{field.label}</h3>, <div className="section">{section}</div>])
            } else {
                helpText = field.args.help_text
                required = field.args.required
                // label defaults to id
                label = field.args.label || field.args.id
                field.type === "float" ? type = "number" : type = field.type
                if (type === "choice" || type === "multiple_choice") {
                    output.push(
                        <div key={`${label}:${field.id}`} className="section">
                            {header(label, null, helpText, required)}
                            {this.renderDropdown(field, field.id, type, errors, touched)}
                        </div>
                    )
                } else {
                    output.push(
                        <div key={`${label}:${field.id}`} className="section">
                            {header(label, null, helpText, required)}
                            {this.renderInput(field, field.id, type, errors, touched)}
                        </div>
                    )
                }
            }
        })
        return output
    }

    render() {
        let initialFormValues = {submit: "submit", geometries: this.state.geometries}
        this.props.data.forEach(field => {
            let createDefaultFormValues = (fieldInfo, group) => {
                let id = null
                let type = ""
                group ? id = `${group}:${fieldInfo.id}` : id = fieldInfo.id
                if (fieldInfo.type === "multiple_choice") {
                    type = []
                }
                initialFormValues[id] = type
            }
            if (field.fields && field.fields.length) {
                field.fields.forEach(f => createDefaultFormValues(f, field.id))
            } else {
                createDefaultFormValues(field)
            }
            if (Object.keys(this.props.responseFields).length !== 0) {
                Object.entries(this.props.responseFields).forEach(
                    ([key, value]) => {
                        if (Object.keys(initialFormValues).includes(key)) {
                            initialFormValues[key] = value
                        }
                    }
                )
            }
        })

        return (
            <div id="SidebarContent">
                <Segment>
                    {this.props.isModifying ?
                        <Popup
                            content="You must finish editing the map before continuing."
                            position="bottom left"
                            trigger={<div><Button disabled type="button"><Icon name="reply"/>{gettext('Back')}</Button></div>}
                        />
                        :
                        <ConfirmModal
                            buttonText={<Button type="button"><Icon name="reply"/>{gettext('Back')}</Button>}
                            header={gettext('Confirm Back?')}
                            content={gettext('All changes will be discarded')}
                            confirm={this.props.onCancel}
                        />
                    }
                    {this.props.responseID === null ?
                        <div className="section new-response-intro">
                            <p>
                                The Florida Conservation Actions Tracker is designed to facilitate sharing information about
                                conservation actions on the landscape: completed, planned, or in progress. In particular, a
                                major goal is to help identify shared priorities across organizations and result in better
                                coordination among organizations responsible for conservation effort across the landscape.
                                Target projects range from restoration to land acquisition to other land management
                                activities.
                            </p>
                            <p>
                                This is a serious effort: please do not create projects simply to test out this
                                functionality (or if you do, please immediately delete them). Projects may be deleted by
                                site administrators at any time if they are deemed not to fit the intent of this
                                application.
                            </p>
                            <p>
                                If you have any questions or would like more information, please contact us at: <a href="mailto:Floridacpa@gmail.com">Floridacpa@gmail.com</a>
                            </p>
                        </div>
                        :
                        null
                    }
                    <Divider />
                    <Formik
                        validateOnChange={false}
                        initialValues={initialFormValues}
                        validate={values => {
                            const validations = this.validations
                            const errors = {}
                            Object.keys(validations).forEach(fieldId => {
                                if (!values[fieldId] || (Array.isArray(values[fieldId]) && !values[fieldId].length)) {
                                    errors[fieldId] = "Required"
                                }
                                if (validations[fieldId].email) {
                                    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values[fieldId])) {
                                        errors[fieldId] = "Invalid email address"
                                    }
                                }
                                if (validations[fieldId].float) {
                                    if (isNaN(values[fieldId])) {
                                        errors[fieldId] = "Must be a number"
                                    }
                                    if (!isNaN(validations[fieldId].min_value)) {
                                        if (values[fieldId] < validations[fieldId].min_value) {
                                            errors[fieldId] = `Must be greater than ${validations[fieldId].min_value}`
                                        }
                                    }
                                }
                            })
                            if (!this.props.map.drawLayer.getLayers().length) {
                                errors.geometries = "Select a geometry from the map"
                            }
                            return errors
                        }}
                        onSubmit={(values) => {
                            let valuesStripped = Object.assign({}, values)
                            delete valuesStripped.submit
                            delete valuesStripped.geometries
                            this.handleSaveClick(valuesStripped)
                        }}
                        render={({
                            values,
                            errors,
                            handleSubmit,
                            handleBlur,
                            handleChange,
                            touched
                        }) => (
                            <Form onSubmit={handleSubmit}>
                                {this.generateFields(this.props.data, values, errors, handleBlur, handleChange, touched)}
                                <h3 className="section-header-divider">Documents</h3>
                                <div className="section">
                                    {this.state.files && this.state.files.length > 0 ?
                                        <div>
                                            {this.state.files.map(doc => {
                                                if (!this.state.filesToDelete.includes(doc.id)) {
                                                    return (
                                                        <div key={doc.file} className="container-space-between">
                                                            <a target="_blank" href={doc.file}>{doc.name}</a>
                                                            <ConfirmModal
                                                                header="Remove File?"
                                                                content="File will be permanently deleted on save."
                                                                confirm={() => this.setState({filesToDelete: [...this.state.filesToDelete, doc.id]})}
                                                                buttonText={<Icon
                                                                    name="trash"
                                                                    link
                                                                />}
                                                            />
                                                        </div>
                                                    )
                                                }
                                            })}
                                        </div> : null
                                    }
                                    {this.state.filesToAdd.map(file => {
                                        return (
                                            <div key={file.fileName} className="container-space-between">
                                                {file.editName === true ?
                                                    <Input
                                                        type="text"
                                                        value={file.newName || file.fileName}
                                                        onChange={(e) => this.setState({filesToAdd: Object.assign(this.state.filesToAdd, Object.assign(file, {newName: e.target.value}))})}
                                                    />
                                                    :
                                                    <a href={file.url}
                                                       target="_blank">{file.newName || file.fileName}</a>
                                                }
                                                <div style={{display: "flex"}}>
                                                    <Popup
                                                        content="Edit Name"
                                                        position="top center"
                                                        trigger={
                                                                    <Icon
                                                                        link
                                                                        name="edit"
                                                                        onClick={() => this.setState({files: Object.assign(this.state.files, Object.assign(file, {editName: !file.editName}))})}
                                                                    />
                                                                }
                                                    />
                                                    <ConfirmModal
                                                        header="Remove File?"
                                                        content="File will be permanently deleted."
                                                        confirm={() => this.setState({filesToAdd: this.state.filesToAdd.filter(entry => entry.uuid !== file.uuid)})}
                                                        buttonText={<Icon
                                                            name="trash"
                                                            link
                                                        />}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                                <br/>
                                <Dropzone
                                    id="dropzonefiles"
                                    disabled={this.state.uploading}
                                    onDrop={this.onDrop.bind(this)}
                                    align="center">
                                    <br/>
                                    {this.state.uploading ?
                                        <Loader inline="centered" active/>
                                        :
                                        <Button type="button" size="small">
                                            <Icon name="upload"/> UPLOAD FILE
                                        </Button>
                                    }
                                </Dropzone>
                                <br/>
                                <Divider/>
                                {Object.keys(this.state.responseErrors).length ?
                                    <div style={{color: "red", paddingBottom: "1rem"}}>
                                        Correct the errors above and resubmit.
                                    </div> : null}
                                {!!Object.keys(errors).length && touched.submit &&
                                <div style={{color: "red", paddingBottom: "1rem"}}>
                                    Please fill out the required fields in red.
                                </div>}
                                {this.props.isModifying ?
                                    <Popup
                                        content="You must finish editing the map before continuing."
                                        position="top center"
                                        trigger={
                                            <div className="container-space-between">
                                                {this.props.responseID ?
                                                    <Button disabled color="black" type="button">{gettext('DELETE')}</Button>
                                                    :
                                                    null
                                                }
                                                <div style={{display: "flex"}}>
                                                    <Button disabled type="button">{gettext('CANCEL')}</Button>
                                                    <Button disabled color="blue" name="submit">SAVE</Button>
                                                </div>
                                            </div>
                                        }
                                    />
                                    :
                                    <div className="container-space-between">
                                        {this.props.responseID ?
                                            <ConfirmModal
                                                buttonText={<Button color="black"
                                                                    type="button">{gettext('DELETE')}</Button>}
                                                header={gettext('Confirm Delete?')}
                                                content={gettext('This conservation action will be permanently deleted.')}
                                                confirm={() => this.destroyResponse()}
                                            />
                                            :
                                            null
                                        }
                                        <div style={{display: "flex"}}>
                                            <ConfirmModal
                                                buttonText={<Button type="button">{gettext('CANCEL')}</Button>}
                                                header={gettext('Confirm Cancel?')}
                                                content={gettext('All changes will be discarded')}
                                                confirm={this.props.onCancel}
                                            />
                                            <Button color="blue" type="submit" name="submit" onClick={handleSubmit}>
                                                SAVE
                                            </Button>
                                        </div>
                                    </div>
                                }
                            </Form>
                        )}
                    />
                </Segment>
            </div>
        );
    }
}

NewResponseTab.propTypes = {
    map: PropTypes.instanceOf(L.Map),
    data: PropTypes.arrayOf(PropTypes.object),
    surveyID: PropTypes.string.isRequired,
    createResponse: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    responseID: PropTypes.number,
    responseFields: PropTypes.object,
    editResponse: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    geometries: PropTypes.arrayOf(PropTypes.object),
    getResponse: PropTypes.func.isRequired
}

NewResponseTab.defaultProps = {
    data: [],
    map: null,
    responseID: null,
    responseFields: {},
    geometries: []
};

const mapStateToProps = state => ({
    isModifying: state.getIn(['site', 'isEditing']),
})

export default connect(mapStateToProps, { updateEditShapesStatus, updateSurveyDefinition, deleteAllLayers, deleteResponse })(NewResponseTab);



// WEBPACK FOOTER //
// ./source/containers/Surveys/Sidebar/NewResponse.jsx